import ajax from '../utils/request'

const systemApi = {
  /********************************版本管理*********************************** */
  // 请求版本管理模块配置列表
  getVersionList(params) {
    return ajax({
      url: '/ver/list',
      type: 'get',
      params: params
    })
  },
  // 删除tags
  getVersionDelets(params) {
    return ajax({
      url: '/ver',
      type: 'delete',
      params: params
    })
  },
  // 编辑tags
  getVersionPut(params) {
    return ajax({
      url: '/ver/update',
      type: 'post',
      params: params
    })
  },
  // 增加tags
  getVersionPost(params) {
    return ajax({
      url: '/ver',
      type: 'post',
      params: params
    })
  }
}
export default systemApi
